import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import NextLink from 'next/link';
import useRoutes from '../useRoutes';
export default function Link(_ref) {
  var as = _ref.as,
      children = _ref.children,
      href = _ref.href,
      _ref$passHref = _ref.passHref,
      passHref = _ref$passHref === void 0 ? true : _ref$passHref,
      _ref$prefetch = _ref.prefetch,
      prefetch = _ref$prefetch === void 0 ? false : _ref$prefetch,
      inputRoute = _ref.route,
      to = _ref.to,
      rest = _objectWithoutProperties(_ref, ["as", "children", "href", "passHref", "prefetch", "route", "to"]);

  var routesContext = useRoutes();
  var route = useMemo(function () {
    // next-routes uses `route` and `to`, we're going to start treating those
    // and `href` all the same and send them through `resolve`.
    return routesContext.resolve(inputRoute || to || href, as);
  }, [as, href, inputRoute, routesContext, to]);
  return /*#__PURE__*/React.createElement(NextLink, _extends({
    href: route.href,
    as: route.asPath,
    passHref: passHref,
    prefetch: prefetch
  }, rest), children);
}
Link.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  passHref: PropTypes.bool,
  prefetch: PropTypes.bool,
  route: PropTypes.string,
  to: PropTypes.string
};